<template>
 
  <b-form-group>
    <label :for="name">{{ label }}</label>
    <b-form-input 
      :ref="name" 
      :id="name" 
      :name="name"
      :type="type" 
      :maxlength="maxLength"
      :minlength="minLength"
      required 
      :placeholder="placeholder" 
      class="form-control" 
      autocomplete="off"
      autofocus>
    </b-form-input>
  </b-form-group>

</template>

<script>
export default {
  name: 'InputPayment',
  props: {
    label: String,
    maxLength: Number,
    minLength: Number,
    name: String,
    regex: String,
    placeholder: String,
    require: Boolean,
    type: String
  }
}
</script>